// Shared tokens for the /tanfolyamok page. One accent colour (the existing
// teal); everything else is white at different opacities on the dark ground.
export const T = {
  bg: '#0d1117',
  accent: '#00D2C8',
  accentSoft: 'rgba(0,210,200,0.10)',
  accentLine: 'rgba(0,210,200,0.28)',
  text: '#ffffff',
  body: 'rgba(255,255,255,0.72)',
  muted: 'rgba(255,255,255,0.52)',
  faint: 'rgba(255,255,255,0.34)',
  line: 'rgba(255,255,255,0.08)',
  surface: 'rgba(255,255,255,0.03)',
  surfaceHover: 'rgba(255,255,255,0.06)',
  radius: 20,
};
